var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success",class:{active:_vm.active}},[_vm._v("O anfitrião já foi notificado da sua presença na recepção. Por favor espere um momento.")])
}
var staticRenderFns = []

export { render, staticRenderFns }